import { useContext, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { DevToolsContext } from './DevTools';
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
const DevTool = ({
  children
}) => {
  const portal = useDevToolPortal();
  if (!portal) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/createPortal(children, portal)
  });
};
const useDevToolPortal = () => {
  const [devToolId, setDevToolId] = useState(null);
  const [registerDevTool, unregisterDevTool, portals] = useContext(DevToolsContext);
  useEffect(() => {
    const id = registerDevTool();
    setDevToolId(id);
    return () => void unregisterDevTool(id);
  }, [registerDevTool, unregisterDevTool]);
  if (!devToolId) {
    return null;
  }
  return portals[devToolId];
};
export default DevTool;